import { ModelEnhancer } from 'state/ModelEnhancer';
export class Asset extends ModelEnhancer {
    createStruct(_data) {
        return null;
    }
}
